import React from "react";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import { useAppSelector } from "src/store/store";
import { setIsProviderPlacedOffWorkModalOpen, setAccommodationSavingStatus } from "src/store/newJmrPageSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ApiCallStatus } from "src/store/type";

const ProviderPlacedOffWorkModal = () => {
  const dispatch = useDispatch();
  const { isProviderPlacedOffWorkModalOpen } = useAppSelector(
    (state) => state.newJmrPage
  );
  const navigate = useNavigate();
  const { site } = useParams();

  const onClose = () => {
    dispatch(setIsProviderPlacedOffWorkModalOpen(false));
    navigate(`/placementsOverview/${site}/pendingPlacements`);
    dispatch(setAccommodationSavingStatus(ApiCallStatus.Idle))
  };

  return (
    <React.Fragment>
      <Modal
        title="Provider Placed Off Work"
        open={isProviderPlacedOffWorkModalOpen}
        width="350px"
        scrollContainer="viewport"
        closeLabel="Close"
      >
        <Text id="modal-description">{`Associate's status has been updated to "Provider Placed Off Work", you will now be directed to the Placements Overview page.`}</Text>
        <ModalFooter>
          <Row alignmentHorizontal="end" widths="fit">
            <Button type="primary" size="small" onClick={onClose}>
              OK
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default ProviderPlacedOffWorkModal;
